import axios from "axios";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { UsuarioModel } from "models/user_model";
import moment from "moment";
import { useEffect, useRef, useState } from "react";

const useFinanceiro = () => {
  const [list, setAccountTypeList] = useState<LancamentoFinanceiro[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] =
    useState<LancamentoFinanceiro>(null);
  const cancelRef = useRef();

  const [dataInicio, setDataInicio] = useState<Date>(new Date());
  const [dataFim, setDataFim] = useState<Date>(new Date());
  const [selectedList, setSelectedList] = useState<LancamentoFinanceiro[]>([]);

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      cleanInput();
    }
  };

  const changeInput = (value: any, type: string) => {
    switch (type) {
      case "inicio":
        setDataInicio(value);
        break;
      case "fim":
        setDataFim(value);
        break;
    }
  };

  const closeError = () => {
    setError(false);
  };
  const add = () => {
    showModal(true);
  };
  const edit = (item: LancamentoFinanceiro) => {
    setAccountSelected(item);
    setShow(true);
  };
  const deletar = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/contas-pagar/" + accountSelected?.id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      showModal(false);
      setAccountSelected(null);
      setShowDelete(false);
    }
  };

  const cleanInput = () => {};

  const loadData = async (dataInicio: string, dataFim: string) => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/lancamento/lancamentodata/${userData?.idEmpresa}/${dataInicio}/${dataFim}`
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setAccountTypeList(response.data);
    }
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const showDeleteModal = (item: LancamentoFinanceiro) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const searchData = async () => {
    setLoading(true);
    const di = moment(dataInicio).add({ day: -1 }).format("YYYY-MM-DD");
    const df = moment(dataFim).add({ day: 1 }).format("YYYY-MM-DD");
    await loadData(di, df);
  };

  const calculateRecebido = () => {
    let total = 0;
    if (list?.length > 0) {
      const listaPg = list.filter((pg) => pg.pago &&
      pg?.texto.toLowerCase().includes("receber"));
      total = listaPg.reduce((acc, value) => Number(value.valor) + acc, 0);
    }

    return total;
  };
  const calculateAReceber = () => {
    let total = 0;
    if (list?.length > 0) {
      const listaPg = list.filter(
        (pg) => !pg.pago && pg?.texto.toLowerCase().includes("receber")
      );
      total = listaPg.reduce((acc, value) => Number(value.valor) + acc, 0);
    }

    return total;
  };

  const calculatePago = () => {
    let total = 0;
    if (list?.length > 0) {
      const listaPg = list.filter(
        (pg) => pg.pago && pg?.texto.toLowerCase().includes("pagar")
      );
      total = listaPg.reduce((acc, value) => Number(value.valor) + acc, 0);
    }

    return total;
  };

  const calculateAPagar = () => {
    let total = 0;
    if (list?.length > 0) {
      const listaPg = list.filter(
        (pg) => !pg.pago && pg?.texto.toLowerCase().includes("pagar")
      );
      total = listaPg.reduce((acc, value) => Number(value.valor) + acc, 0);
    }

    return total;
  };

  const calculateRecebimentosAtraso = () => {
    let total = 0;
    if (list?.length > 0) {
      const listaPg = list.filter(
        (pg) =>
          !pg.pago &&
          moment(pg?.vencimento).add({ day: 1 }).isBefore(moment(new Date())) &&
          pg?.texto.toLowerCase().includes("receber")
      );
      total = listaPg.reduce((acc, value) => Number(value.valor) + acc, 0);
    }

    return total;
  };

  const calculatePagamentosAtraso = () => {
    let total = 0;
    if (list?.length > 0) {
      const listaPg = list.filter(
        (pg) =>
          !pg.pago &&
          moment(pg?.vencimento).add({ day: 1 }).isBefore(moment(new Date())) &&
          pg?.texto.toLowerCase().includes("pagar")
      );
      total = listaPg.reduce((acc, value) => Number(value.valor) + acc, 0);
    }

    return total;
  };

  const calculateCaixa = () => {
    const recebidos = Number(calculateAReceber()) + Number(calculateRecebido());
    const parapagar = Number(calculateAPagar());
    let total = recebidos - parapagar;
    return total;
  };

  const addToList = (item: LancamentoFinanceiro) => {
    let newList: LancamentoFinanceiro[] = [...selectedList];
    const existe = newList.find((a) => a.id === item.id);
    if (existe) {
      newList = newList.filter((a) => a !== item);
    } else {
      newList.push(item);
    }
    setSelectedList(newList);
  };

  const pagar = async () => {
    setLoading(true);
    if (selectedList?.length > 0) {
      for (let i = 0; i < selectedList.length; i++) {
        const element = selectedList[i];

        await axios.patch(
          process.env.REACT_APP_API_URL + "/lancamento/pagar/" + element.id
        );
      }
      setTimeout(async () => {
        const di = moment(new Date())
        .startOf("month")
        .add({ day: -1 })
        .format("YYYY-MM-DD");
      const df = moment(new Date())
        .endOf("month")
        .add({ day: 1 })
        .format("YYYY-MM-DD");
        await loadData(di, df); 
      }, 300);
    } else {
      showError(
        "Erro!",
        "Você deve selecionar ao menos um registro para fazer o pagamento"
      );
    }
    setLoading(false);
    setSelectedList([]);
  };

  const removerPagamento = async () => {
    setLoading(true);
    if (selectedList?.length > 0) {
      for (let i = 0; i < selectedList.length; i++) {
        const element = selectedList[i];

        await axios.patch(
          process.env.REACT_APP_API_URL + "/lancamento/removerpagamento/" + element.id
        );
      }
      setTimeout(async () => {
        const di = moment(new Date())
        .startOf("month")
        .add({ day: -1 })
        .format("YYYY-MM-DD");
      const df = moment(new Date())
        .endOf("month")
        .add({ day: 1 })
        .format("YYYY-MM-DD");
        await loadData(di, df); 
      }, 300);

    } else {
      showError(
        "Erro!",
        "Você deve selecionar ao menos um registro para retirar o pagamento"
      );
    }
    setLoading(false);
    setSelectedList([]);
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  useEffect(() => {
    const initialize = async () => {
      const di = moment(new Date())
        .startOf("month")
        .add({ day: -1 })
        .format("YYYY-MM-DD");
      const df = moment(new Date())
        .endOf("month")
        .add({ day: 1 })
        .format("YYYY-MM-DD");
      try {
        await Promise.all([loadData(di, df)]);
      } catch (error) {
        // Handle errors if needed
        console.error("Error during initialization:", error);
      }
    };

    initialize();
  }, []);

  return {
    list,
    usuario,
    loading,
    show,
    error,
    errorTitle,
    errorMsg,
    showDelete,
    accountSelected,
    showModal,
    changeInput,
    cancelRef,
    closeError,
    closeDelete,
    add,
    deletar,
    edit,
    showDeleteModal,
    dataFim,
    dataInicio,
    searchData,
    calculateRecebido,
    calculateAReceber,
    calculateAPagar,
    calculatePago,
    calculateRecebimentosAtraso,
    calculatePagamentosAtraso,
    calculateCaixa,
    addToList,
    pagar,
    removerPagamento,
    selectedList
  };
};

export default useFinanceiro;
